import React from 'react';
import { Link } from 'react-router-dom';

const ForbiddenPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center bg-gray-100 p-4">
      <h1 className="text-6xl font-bold text-red-500 mb-4">403</h1>
      <h2 className="text-2xl font-semibold text-gray-800 mb-2">Рұқсат жоқ</h2>
      <p className="text-gray-600 mb-6">Кешіріңіз, сізде бұл бетті көруге рұқсат жоқ.</p>
      <Link to="/" className="px-6 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition">
        Басты бетке оралу
      </Link>
    </div>
  );
};
export default ForbiddenPage;